import { ITableColumn } from '@components/common/UTable/UTable';
import dayjs from 'dayjs';
import _ from 'lodash';

import { indexCol } from '@/pages/Report/columns/commonColumns';
import { MortalityReport } from '@/pages/Report/types';

// Строка с превышением норматива выделяется красным (только если норматив задан).
export const onExceededCell = (record: MortalityReport) =>
  !_.isNil(record.normPercent) && record.isExceeded
    ? { style: { color: '#E31F1F' } }
    : {};

const formatPercent = (value?: number | null) =>
  _.isNil(value) ? '-' : Number(value).toFixed(2);

export const mortalityColumns: ITableColumn[] = [
  { ...indexCol, onCell: onExceededCell },
  {
    title: 'Хозяйство',
    dataIndex: 'organizationName',
    key: 'organizationName',
    sorter: true,
    width: 200,
    onCell: onExceededCell,
  },
  {
    title: 'Месяц',
    dataIndex: 'periodMonth',
    key: 'periodMonth',
    sorter: true,
    width: 100,
    render: (value?: string) => (value ? dayjs(value).format('MM.YYYY') : '-'),
    onCell: onExceededCell,
  },
  {
    // Сортировка по порядку группы из справочника, а не по названию.
    title: 'Возрастная группа',
    dataIndex: 'ageGroupOrderNumber',
    key: 'ageGroupOrderNumber',
    sorter: true,
    width: 130,
    render: (_value: number, record: MortalityReport) => record.ageGroupName,
    onCell: onExceededCell,
  },
  {
    title: 'Поголовье',
    dataIndex: 'herdAmount',
    key: 'herdAmount',
    sorter: true,
    width: 110,
    onCell: onExceededCell,
  },
  {
    title: 'Пало',
    dataIndex: 'deadAmount',
    key: 'deadAmount',
    sorter: true,
    width: 90,
    onCell: onExceededCell,
  },
  {
    title: 'Падёж, %',
    dataIndex: 'mortalityPercent',
    key: 'mortalityPercent',
    sorter: true,
    width: 100,
    render: formatPercent,
    onCell: onExceededCell,
  },
  {
    title: 'Норматив, %',
    dataIndex: 'normPercent',
    key: 'normPercent',
    sorter: true,
    width: 110,
    render: formatPercent,
    onCell: onExceededCell,
  },
  {
    title: 'Превышение',
    dataIndex: 'isExceeded',
    key: 'isExceeded',
    sorter: true,
    width: 110,
    render: (value: boolean, record: MortalityReport) =>
      _.isNil(record.normPercent) ? '-' : value ? 'Да' : 'Нет',
    onCell: onExceededCell,
  },
];
